// extracted by css-extract-rspack-plugin
export default {"wrapper":"uHIiM"};